import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import {
  CreatorStatsListResponseDto,
  CreatorStatsRowDto,
  FilterCreatorStatsDto,
} from '../molecules/creator-stats/creator-stats.types';
import {
  CreatorStatsAggregateResponseDto,
  FilterStatsAggregateDto,
} from '../molecules/admin-stats-aggregate/admin-stats-aggregate.types';

@Injectable({
  providedIn: 'root',
})
export class AdminCreatorStatsService {
  private readonly http = inject(HttpClient);
  private readonly api = environment.shout_api.url;

  list(filter: FilterCreatorStatsDto): Observable<CreatorStatsListResponseDto> {
    return this.http.post<CreatorStatsListResponseDto>(`${this.api}/creator-stats/admin/list`, filter);
  }

  aggregate(filter: FilterStatsAggregateDto): Observable<CreatorStatsAggregateResponseDto> {
    return this.http.post<CreatorStatsAggregateResponseDto>(
      `${this.api}/creator-stats/admin/aggregate`,
      filter,
    );
  }
}
